import { format } from 'date-fns';
import { TestsData, TestsParser } from './types';

const lessonsParser = (data: TestsData): TestsParser => ({
  date: data!.schedule_run_before ? format(data!.schedule_run_before, 'YYYY-MM-DD') : '',
  items: [
    {
      type: 'tests',
      id: data!.id || '',
      time: data!.schedule_run_before ? format(data!.schedule_run_before, 'HH:mm') : '',
      title: data!.subject || '',
      announce: data!.announce || '',
      description: data!.description || '',
      links: data!.links || [],
      files: data!.files || [],
      result: data!.result || null,
      events_name: data!.events_name || '',
      group_id: data!.group_id || '',
      group_name: data!.group_name || '',
      module_name: data!.module_name || '',
      schedule_run_before: data!.schedule_run_before
        ? format(data!.schedule_run_before, 'YYYY-MM-DD')
        : '',
      theme_name: data!.theme_name || '',
      lesson_name: data!.lesson_name || '',
      schedule_id: data!.schedule_id || '',
      videos: data!.videos || [],
    },
  ],
});

export default lessonsParser;



// WEBPACK FOOTER //
// ./src/services/api/remoteedu/utils/testsParser.ts